RivalIQ.apps.Site.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.ContactMe = Backbone.Model.extend({
        url: function () {
            return '/contactme';
        },
        parse: function (data) {
            if (data.error) {
                return {
                    error: true
                };
            }
            return data.data;
        }
    });

});
